const programStatuses = () => {
  return {
    inactive: 'inactive',
    active: 'active',
    disabled: 'disabled',
    completed: 'completed',
  }
}

const getProgramStatusColors = (status) => {
  switch (status) {
    case programStatuses().inactive:
      return {
        color: '#fff',
        background: '#95a5a6',
      }
    case programStatuses().active:
      return {
        color: '#fff',
        background: '#3498db',
      }
    case programStatuses().disabled:
      return {
        color: '#fff',
        background: '#dc3545',
      }
    case programStatuses().completed:
      return {
        color: '#fff',
        background: '#28a745',
      }
    default:
      return {
        color: '#999',
        background: '#fff',
      }
  }
}

export { programStatuses, getProgramStatusColors }
